import {
  ONE_TRUST_COOKIE_GROUPS_CATEGORY,
  NECESSARY_COOKIES_ID,
  SITE_ANALYTICS_COOKIES_ID,
  CUSTOMER_PREFERENCES_COOKIES_ID,
  TARGETING_AND_ADVERTISING_COOKIES_ID,
  SOCIAL_MEDIA_COOKIES_ID
} from "./constants";

/**
 * Get the current consent from the OneTrust cookie value.
 *
 * If the value does not contain the consent groups then `null` is returned.
 *
 * @param {string} cookieConsentString The cookie consent string.
 * @returns {object|null}
 */
export const getConsentFromCookieString = cookieConsentString => {
  const consentProperties = new URLSearchParams(cookieConsentString);
  const consentGroupsString = consentProperties.get(
    ONE_TRUST_COOKIE_GROUPS_CATEGORY
  );

  if (!consentGroupsString) {
    return null;
  }

  return {
    [NECESSARY_COOKIES_ID]: true,
    [SITE_ANALYTICS_COOKIES_ID]: cookieConsentString.includes(
      `${SITE_ANALYTICS_COOKIES_ID}:1`
    ),
    [CUSTOMER_PREFERENCES_COOKIES_ID]: cookieConsentString.includes(
      `${CUSTOMER_PREFERENCES_COOKIES_ID}:1`
    ),
    [TARGETING_AND_ADVERTISING_COOKIES_ID]: cookieConsentString.includes(
      `${TARGETING_AND_ADVERTISING_COOKIES_ID}:1`
    ),
    [SOCIAL_MEDIA_COOKIES_ID]: cookieConsentString.includes(
      `${SOCIAL_MEDIA_COOKIES_ID}:1`
    )
  };
};
